import { Button, Form, Input } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import styled from 'styled-components';

export const StyledDisabledButton = styled(Button)`
  margin-bottom: 15px;
  min-width: 205px;
  border-radius: 15px;
`;

export const HeaderWithSeparator = styled.span`
  position: relative;
  padding-right: 20px;
`;

export const HeaderSeparatorLine = styled.span`
  display: none;
`;

export const datePickerStyle = {
  width: '100%',
  border: 'none',
  marginTop: '15px'
};

export const startDateCellStyle = {
  borderRight: '0.5px solid #d9d9d9',
  padding: '8px 12px 8px 8px'
};

export const endDateCellStyle = {
  padding: '8px 8px 8px 12px'
};

export const headerCellNoBorder = {
  border: 'none'
};

export const ProcessHeaderWithSeparator = styled.span`
  position: relative;
  padding-right: 40px;
  display: inline-block;

  .ant-table-filter-trigger {
    margin-left: 50px;
    transform: translateY(-10px) !important;
  }

  & + .ant-table-filter-trigger {
    transform: translateY(-10px) !important;
  }
`;

export const ProcessHeaderSeparatorLine = styled.span`
  display: none;
`;

export const processValidityHeaderStyle = {
  paddingTop: '0px',
  paddingBottom: '0px',
  borderBottom: 'none',
  verticalAlign: 'top',
  height: '40px'
};

export const processValidityHeaderStyleL4 = {
  paddingTop: '70px',
  borderBottom: 'none'
};

export const processDateHeaderNoBorder = {
  border: 'none',
  borderBottom: 'none'
};

export const processDateHeaderWithBorder = {
  border: 'none',
  borderBottom: 'none'
};

export const startDateCellBorderStyle = {
  borderRight: '0.5px solid #d9d9d9',
  paddingTop: '15px',
  paddingBottom: '15px'
};

export const endDateCellPaddingStyle = {
  paddingTop: '15px',
  paddingBottom: '15px'
};

export const controlValidityHeaderStyle = {
  paddingTop: '0px',
  paddingBottom: '0px',
  borderBottom: 'none',
  verticalAlign: 'top',
  height: '40px'
};

export const ControlValidityHeaderWrapper = styled.div`
  margin-top: -19px;
  position: relative;
  padding-right: 40px;
`;

export const ControlValiditySeparatorLine = styled.span`
  display: none;
`;

export const getControlValidityFilterStyle = () => `
  .ant-table-thead > tr > th:has(.control-validity-header) .ant-table-filter-trigger {
    transform: translate(90px, -13px) !important;
  }
`;

export const SearchHeaderContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: nowrap;
  white-space: nowrap;
  overflow: visible;
  min-height: 40px;
`;

export const SearchIcon = styled.span`
  font-size: 18px;
  cursor: pointer;
`;

export const SearchInput = styled.input`
  width: 120px;
  height: 24px;
  padding: 4px 11px;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  font-size: 14px;

  &:focus {
    outline: none;
    border-color: #1890ff;
  }
`;

export const WideSearchInput = styled(Input)`
  width: 150px !important;
  min-width: 150px;
  flex-shrink: 0;
`;

export const ProcessSearchIcon = styled(SearchOutlined)`
  font-size: 18px;
  cursor: pointer;
  flex-shrink: 0;
`;

export const keyControlSelectStyle = {
  width: '100%'
};

export const readOnlyFieldStyle = {
  padding: '8px'
};

export const ProcessValidityHeaderWrapper = styled.div`
  margin-top: -12px;
`;

export const getProcessValidityFilterStyle = (processLevel?: string) => `
  .ant-table-thead > tr > th:has(.process-validity-header) .ant-table-filter-trigger {
    transform: translate(${
      processLevel === 'L1' ? '90px' : '60px'
    }, -13px) !important;
  }
`;
